define('views/content/orders',['require','views/base/list_page_view','views/components/transaction/transactions','collections/transactions','text!templates/content/orders.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var TransactionsView = require('views/components/transaction/transactions');
    var TransactionsCollection = require('collections/transactions');

    var temp = require("text!templates/content/orders.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'product-page',
        titleKey: 'orders',

        setCollection: function () {
            this.collection = new TransactionsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new TransactionsView({
                collection: this.collection
            }));
        }

    });
});
